import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncateText'
})
export class TruncateTextPipe implements PipeTransform {
    public transform(value: string, truncateAfter?: number, reversed?: boolean): string {
        if (typeof truncateAfter !== 'number' || !value || value.length <= truncateAfter) {
            return value;
        } else if (reversed === true) {
            return `...${value.substr(value.length - truncateAfter)}`;
        } else {
            return `${value.substr(0, truncateAfter)}...`;
        }
    }
}
